const STATUS = ["published", "draft"];
const SUBJECTS = ["chinese", "math", "culture", "poetry", "science", "logic"];

export const SCHEMAS = {
  stories: {
    key: "story_id", label: "Stories", singular: "story", columns: ["story_number", "story_title", "map_location", "status"],
    fields: [
      ["story_id", "text"], ["story_title", "text"], ["story_number", "number"], ["description", "textarea"], ["thumbnail", "image"],
      ["map_location", "text"], ["map_x", "number"], ["map_y", "number"], ["difficulty_level", "number"], ["estimated_minutes", "number"],
      ["unlock_requirement", "story"], ["status", STATUS], ["subject_type", SUBJECTS], ["badge_name", "text"], ["sticker", "text"],
      ["tone_focus", "json"], ["zhuyin_review_all", "bool"], ["missions", "json"], ["hall", ["classic", "life"]], ["theme", "text"], ["theme_order", "number"],
    ],
  },
  art_activities: {
    key: "activity_id", label: "畫坊・活動", singular: "art activity", columns: ["order", "kind", "title", "status"],
    fields: [["activity_id", "text"], ["kind", "text"], ["title", "text"], ["order", "number"], ["prompt", "textarea"], ["story", "textarea"],
      ["line_url", "image"], ["status", STATUS]],
  },
  speak_topics: {
    key: "topic_id", label: "我會說・主題", singular: "speaking topic", columns: ["order", "emoji", "title", "badge_name", "status"],
    fields: [["topic_id", "text"], ["title", "text"], ["emoji", "text"], ["color", "text"], ["order", "number"], ["badge_name", "text"], ["scene", "textarea"],
      ["cover_image", "image"], ["dialogue", "json"], ["status", STATUS]],
  },
  speak_sentences: {
    key: "sentence_id", label: "我會說・句子", singular: "speaking sentence", columns: ["topic_id", "order", "text", "situation", "status"],
    fields: [["sentence_id", "text"], ["topic_id", "text"], ["order", "number"], ["text", "text"], ["situation", "text"], ["audio_url", "audio"], ["status", STATUS]],
  },
  themes: {
    key: "theme_id", label: "生活主題", singular: "life theme", columns: ["order", "emoji", "name", "badge_name"],
    fields: [["theme_id", "text"], ["name", "text"], ["emoji", "text"], ["color", "text"], ["badge_name", "text"], ["order", "number"], ["background", "image"]],
  },
  vocab: {
    key: "word_id", label: "生活詞彙", singular: "life word", columns: ["lesson_id", "word", "zhuyin", "emoji", "meaning"], filter: "lesson_id",
    fields: [["word_id", "text"], ["lesson_id", "story"], ["word", "text"], ["zhuyin", "text"], ["emoji", "text"], ["meaning", "text"], ["order", "number"],
      ["theme", "text"], ["audio_url", "audio"], ["image_url", "image"]],
  },
  patterns: {
    key: "pattern_id", label: "實用句型", singular: "sentence pattern", columns: ["lesson_id", "pattern", "examples"], filter: "lesson_id",
    fields: [["pattern_id", "text"], ["lesson_id", "story"], ["pattern", "text"], ["examples", "json"], ["order", "number"]],
  },
  scenes: {
    key: "scene_id", label: "Scenes", singular: "scene", columns: ["story_id", "scene_order", "narration_text"], filter: "story_id",
    fields: [
      ["scene_id", "text"], ["story_id", "story"], ["scene_order", "number"], ["background_asset", "image"], ["narration_text", "textarea"],
      ["narration_audio", "audio"], ["dialogue_text", "json"], ["dialogue_audio", "audio"], ["character_assets", "json"],
      ["animation_config", "json"], ["interactive_objects", "json"], ["duration", "number"], ["next_scene", "text"],
    ],
  },
  zhuyin: {
    key: "zhuyin_id", label: "Zhuyin", singular: "zhuyin symbol", columns: ["std_order", "symbol", "mnemonic", "category", "lesson_introduced"],
    fields: [
      ["zhuyin_id", "text"], ["symbol", "text"], ["category", ["initial", "medial", "final"]], ["order", "number"], ["audio_text", "text"],
      ["audio_url", "audio"], ["example_character", "text"], ["example_word", "text"], ["example_zhuyin", "text"], ["image_asset", "text"],
      ["image_url", "image"], ["mnemonic", "text"], ["card_image", "image"], ["strokes", "json"], ["std_order", "number"], ["stroke_animation", "text"], ["lesson_introduced", "number"], ["difficulty", "number"],
    ],
  },
  characters: {
    key: "character_id", label: "Characters", singular: "character", columns: ["traditional_character", "zhuyin", "meaning", "lesson_introduced"],
    fields: [
      ["character_id", "text"], ["traditional_character", "text"], ["zhuyin", "text"], ["tone", "number"], ["meaning", "text"],
      ["audio_url", "audio"], ["image_asset", "text"], ["image_url", "image"], ["stroke_order_asset", "text"], ["example_word", "text"],
      ["example_sentence", "text"], ["lesson_introduced", "number"], ["difficulty", "number"], ["subject_type", SUBJECTS],
      ["math_context", "textarea"], ["idiom_context", "textarea"], ["story_context", "textarea"],
    ],
  },
  activities: {
    key: "activity_id", label: "Activities", singular: "activity", columns: ["lesson_id", "activity_order", "activity_type", "instruction", "status"], filter: "lesson_id",
    fields: [
      ["activity_id", "text"], ["lesson_id", "story"], ["activity_order", "number"],
      ["activity_type", ["listen_choose", "picture_match", "zhuyin_match", "scene_search", "comprehension", "speaking"]],
      ["instruction", "text"], ["question_data", "json"], ["answer_options", "json"], ["correct_answer", "text"], ["audio_asset", "audio"],
      ["items", "json"], ["difficulty", "number"], ["points", "number"], ["attempt_limit", "number"], ["status", STATUS], ["subject_type", SUBJECTS],
    ],
  },
  pronunciations: {
    key: "pron_id", label: "讀音修正", singular: "pronunciation fix", columns: ["word", "zhuyin", "pinyin", "note", "status"],
    fields: [["pron_id", "text"], ["word", "text"], ["zhuyin", "text"], ["note", "text"], ["status", STATUS]],
  },
};
